import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Paper, IconButton, Collapse, Dialog } from '@mui/material';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Visibility as OverviewIcon,
  Fullscreen as FullscreenIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

// ---- تصاویر ----
import img01 from '../assets/images/nama/0-1.JPG';
import img02 from '../assets/images/nama/0-2.JPG';
import img03 from '../assets/images/nama/0-3.JPG';
import img05 from '../assets/images/nama/0-5.JPG';
import img06 from '../assets/images/nama/0-6.JPG';
import img07 from '../assets/images/nama/0-7.JPG';
import i1 from '../assets/images/nama/1.JPG';
import i2 from '../assets/images/nama/2.JPG';
import i3 from '../assets/images/nama/3.JPG';
import i4 from '../assets/images/nama/4.JPG';
import i5 from '../assets/images/nama/5.JPG';
import i6 from '../assets/images/nama/6.JPG';
import i7 from '../assets/images/nama/7.JPG';
import i8 from '../assets/images/nama/8.JPG';
import i9 from '../assets/images/nama/9.JPG';
import i10 from '../assets/images/nama/10.JPG';
import i11 from '../assets/images/nama/11.JPG';
import i12 from '../assets/images/nama/12.JPG';
import i13 from '../assets/images/nama/13.JPG';

const GRADIENT = 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)';
const GOLD = '#ffd54f';

// ---- داده‌ها: کپشن‌ها همگی قابل ویرایش هستند ----
const SECTIONS = [
  {
    key: 'overview', badge: 'نمای کلی', title: 'نمای کلی برنامه',
    slides: [
      { img: img01, caption: 'مدیریت سفارشات و پیگیری وضعیت آن ها' },
      { img: img02, caption: 'ایجاد چند فروشنده برای فروشگاه با دسترسی محدود' },
      { img: img03, caption: 'ایجاد و مدیریت خیاط های شخصی شما' },
      { img: img05, caption: 'ایجاد و مدیریت نصب های شخصی شما' },
      { img: img06, caption: 'آمار فروش'},
      { img: img07, caption: 'مدیریت مشتریان و نگهداری اطلاعات آن ها' },
    ],
  },
  {
    key: 'preorder', badge: 'مرحله ۱', title: 'پیش‌سفارش',
    slides: [
      { img: i1, caption: 'قابلیت ثبت مشتری جدید یا استفاده از اطلاعات مشتریان قدیمی' },
      { img: i2, caption: 'ثبت اطلاعات درخواستی مشتری در مرحلهٔ پیش‌سفارش' },
    ],
  },
  {
    key: 'measure', badge: 'مرحله ۲', title: 'اندازه‌گیری',
    slides: [
      { img: i3, caption: 'ثبت دقیق اطلاعات با انواع پارچه' },
      { img: i4, caption: 'افزودن چند اندازه‌گیری برای یک سفارش' },
    ],
  },
  {
    key: 'invoice', badge: 'مرحله ۳', title: 'ثبت فاکتور',
    slides: [
      { img: i5, caption: 'فاکتور زدن راحت و سریع' },
      { img: i6, caption: 'اقلام از قبل آماده هستند' },
      { img: i7, caption: 'محاسبات اتوماتیک و کامل' },
      { img: i8, caption: 'فاکتوری کامل با قابلیت چاپ PDF' },
    ],
  },
  {
    key: 'tailor', badge: 'مرحله ۴', title: 'انتخاب خیاط',
    slides: [
      { img: i9, caption: 'انتخاب خیاط شخصی شما با دستور کار و اندازه‌گیری‌های سفارش' },
      { img: i10, caption: 'PDF آمادهٔ ارسال به خیاط با قابلیت چاپ' },
    ],
  },
  {
    key: 'installer', badge: 'مرحله ۵', title: 'انتخاب نصاب',
    slides: [
      { img: i11, caption: 'انتخاب نصاب شما و ارسال اطلاعات به نصاب' },
      { img: i12, caption: '' },
    ],
  },
  {
    key: 'tracking', badge: 'مرحله ۶', title: 'پیگیری سفارش',
    slides: [
      { img: i12, caption: '' },
      { img: i13, caption: 'پیگیری و شفافیت سفارش‌ها در هر مرحله تا نصب' },
    ],
  },
];

const dotSx = (activeDot) => ({
  width: activeDot ? 24 : 8, height: 8, borderRadius: 4,
  cursor: 'pointer', transition: 'all .25s',
});

// ====== اسلایدر هر بخش ======
const ImageSlider = ({ slides, onExpand }) => {
  const [idx, setIdx] = useState(0);
  const multiple = slides.length > 1;
  const go = (d) => setIdx((p) => (p + d + slides.length) % slides.length);
  const slide = slides[idx];

  return (
    <Box>
      <Box sx={{
        position: 'relative', borderRadius: 2, overflow: 'hidden',
        bgcolor: '#0d1642', boxShadow: '0 6px 24px rgba(13,22,66,0.25)',
      }}>
        <Box
          component="img"
          src={slide.img}
          alt={slide.caption || ''}
          onClick={() => onExpand(slides, idx)}
          sx={{
            width: '100%', height: 'auto', display: 'block',
            maxHeight: { xs: 320, sm: 480, md: '72vh' },
            objectFit: 'contain', cursor: 'zoom-in',
          }}
        />

        {/* دکمهٔ تمام‌صفحه */}
        <IconButton
          onClick={() => onExpand(slides, idx)}
          size="small"
          sx={{ position: 'absolute', top: 8, left: 8, bgcolor: 'rgba(255,255,255,0.85)', '&:hover': { bgcolor: '#fff' } }}
        >
          <FullscreenIcon />
        </IconButton>

        {multiple && (
          <>
            <IconButton onClick={() => go(-1)}
              sx={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', bgcolor: 'rgba(255,255,255,0.85)', '&:hover': { bgcolor: '#fff' } }}>
              <ChevronRightIcon />
            </IconButton>
            <IconButton onClick={() => go(1)}
              sx={{ position: 'absolute', top: '50%', left: 8, transform: 'translateY(-50%)', bgcolor: 'rgba(255,255,255,0.85)', '&:hover': { bgcolor: '#fff' } }}>
              <ChevronLeftIcon />
            </IconButton>
          </>
        )}
      </Box>

      {slide.caption ? (
        <Typography sx={{ textAlign: 'center', mt: 2, fontWeight: 600, color: '#37474f', lineHeight: 2 }}>
          {slide.caption}
        </Typography>
      ) : (
        <Box sx={{ height: 8 }} />
      )}

      {multiple && (
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 1 }}>
          {slides.map((_, i) => (
            <Box key={i} onClick={() => setIdx(i)}
              sx={{ ...dotSx(i === idx), bgcolor: i === idx ? '#1a237e' : '#c5cae9' }} />
          ))}
        </Box>
      )}
    </Box>
  );
};

// ====== لایت‌باکس (پاپ‌اپ تمام‌صفحه) ======
const Lightbox = ({ data, onClose }) => {
  const open = Boolean(data);
  const slides = data?.slides || [];
  const [idx, setIdx] = useState(0);

  useEffect(() => { if (data) setIdx(data.index || 0); }, [data]);

  const multiple = slides.length > 1;
  const go = (d) => setIdx((p) => (p + d + slides.length) % slides.length);
  const slide = slides[idx];

  return (
    <Dialog open={open} onClose={onClose} fullScreen
      PaperProps={{ sx: { bgcolor: 'rgba(13,22,66,0.97)' } }}>
      <IconButton onClick={onClose}
        sx={{ position: 'absolute', top: 12, left: 12, zIndex: 2, color: '#fff', bgcolor: 'rgba(255,255,255,0.12)', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } }}>
        <CloseIcon />
      </IconButton>

      {slide && (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: { xs: 2, md: 4 } }}>
          <Box component="img" src={slide.img} alt={slide.caption || ''}
            sx={{ maxWidth: '95vw', maxHeight: '82vh', objectFit: 'contain', borderRadius: 2 }} />
          {slide.caption ? (
            <Typography sx={{ color: '#fff', mt: 2, fontWeight: 600, textAlign: 'center' }}>
              {slide.caption}
            </Typography>
          ) : null}
          {multiple && (
            <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
              {slides.map((_, i) => (
                <Box key={i} onClick={() => setIdx(i)}
                  sx={{ ...dotSx(i === idx), bgcolor: i === idx ? GOLD : 'rgba(255,255,255,0.4)' }} />
              ))}
            </Box>
          )}
        </Box>
      )}

      {multiple && (
        <>
          <IconButton onClick={() => go(-1)}
            sx={{ position: 'absolute', top: '50%', right: 16, transform: 'translateY(-50%)', color: '#1a237e', bgcolor: 'rgba(255,255,255,0.9)', '&:hover': { bgcolor: '#fff' } }}>
            <ChevronRightIcon fontSize="large" />
          </IconButton>
          <IconButton onClick={() => go(1)}
            sx={{ position: 'absolute', top: '50%', left: 16, transform: 'translateY(-50%)', color: '#1a237e', bgcolor: 'rgba(255,255,255,0.9)', '&:hover': { bgcolor: '#fff' } }}>
            <ChevronLeftIcon fontSize="large" />
          </IconButton>
        </>
      )}
    </Dialog>
  );
};

// ====== کامپوننت اصلی (فقط با کلیک باز می‌شود) ======
const AppShowcase = () => {
  const [active, setActive] = useState(SECTIONS[0].key);
  const [lightbox, setLightbox] = useState(null); // { slides, index }
  const refs = useRef({});

  // باز/بسته کردن فقط با کلیک؛ با باز شدن یکی، بقیه بسته می‌شوند
  const toggle = (key) => {
    setActive((prev) => (prev === key ? '' : key));
    // بخشِ باز را به‌نرمی توی دید بیاور (به‌خاطر جمع‌شدن بخش‌های دیگر)
    setTimeout(() => {
      const el = refs.current[key];
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 320);
  };

  const onExpand = (slides, index) => setLightbox({ slides, index });

  return (
    <Box sx={{ mt: { xs: 4, md: 6 } }}>
      <Typography variant="h5" sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1a237e', mb: 1 }}>
        محیط برنامه را ببینید
      </Typography>
      <Typography sx={{ textAlign: 'center', color: 'text.secondary', mb: 4 }}>
        روی هر مرحله یا دکمهٔ + کلیک کنید تا باز شود
      </Typography>

      {SECTIONS.map((sec) => {
        const open = active === sec.key;
        return (
          <Paper
            key={sec.key}
            ref={(el) => { refs.current[sec.key] = el; }}
            elevation={open ? 6 : 1}
            sx={{
              mb: 2, borderRadius: 3, overflow: 'hidden',
              scrollMarginTop: '90px',
              border: open ? '1px solid #c5cae9' : '1px solid transparent',
              transition: 'box-shadow .3s, border-color .3s',
            }}
          >
            {/* سربرگ */}
            <Box
              onClick={() => toggle(sec.key)}
              sx={{
                display: 'flex', alignItems: 'center', gap: 1.5, p: 2,
                cursor: 'pointer', userSelect: 'none',
                background: open ? GRADIENT : '#fff',
                color: open ? '#fff' : '#1a237e',
                transition: 'background .3s',
              }}
            >
              <Box sx={{
                minWidth: 44, height: 44, px: 1, borderRadius: 2,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                bgcolor: open ? 'rgba(255,255,255,0.18)' : 'rgba(26,35,126,0.08)',
                color: open ? GOLD : '#1a237e', fontWeight: 'bold', fontSize: 13,
                whiteSpace: 'nowrap',
              }}>
                {sec.key === 'overview' ? <OverviewIcon /> : sec.badge}
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                {sec.title}
              </Typography>
              <IconButton
                size="small"
                onClick={(e) => { e.stopPropagation(); toggle(sec.key); }}
                sx={{
                  color: open ? '#1a237e' : '#fff',
                  bgcolor: open ? GOLD : '#1a237e',
                  '&:hover': { bgcolor: open ? '#ffca28' : '#0d1642' },
                }}
              >
                {open ? <RemoveIcon /> : <AddIcon />}
              </IconButton>
            </Box>

            {/* محتوا */}
            <Collapse in={open} timeout={300} unmountOnExit>
              <Box sx={{ p: { xs: 2, md: 3 } }}>
                <ImageSlider slides={sec.slides} onExpand={onExpand} />
              </Box>
            </Collapse>
          </Paper>
        );
      })}

      <Lightbox data={lightbox} onClose={() => setLightbox(null)} />
    </Box>
  );
};

export default AppShowcase;